import { RolesEnum } from "modules/rolesEnum";
import {
  Truck,
  GeoAltFill,
  PinMap,
  CalendarX,
  Speedometer,
  Gear,
  Tablet,
  Alarm,
  Map
} from "react-bootstrap-icons";

export enum IconType {
  Collectors = "Collectors",
  HwrcSites = "HwrcSites",
  DisposalSites = "DisposalSites",
  Regions = "Regions",
  NonWorkingPeriods = "NonWorkingPeriods",
  FillThreshold = "FillThreshold",
  SLA = "SLA",
  SystemSetup = "SystemSetup"
}

export const IconPermission: Record<IconType, RolesEnum[]> = {
  [IconType.Collectors]: [RolesEnum.SuperAdmin, RolesEnum.Admin],
  [IconType.HwrcSites]: [RolesEnum.SuperAdmin, RolesEnum.Admin],
  [IconType.DisposalSites]: [RolesEnum.SuperAdmin, RolesEnum.Admin],
  [IconType.Regions]: [RolesEnum.SuperAdmin, RolesEnum.Admin],
  [IconType.NonWorkingPeriods]: [RolesEnum.SuperAdmin, RolesEnum.Admin],
  [IconType.FillThreshold]: [RolesEnum.SuperAdmin, RolesEnum.Admin],
  [IconType.SLA]: [RolesEnum.SuperAdmin, RolesEnum.Admin],
  [IconType.SystemSetup]: [RolesEnum.SuperAdmin]
};

export const IconTypeClass: Record<IconType, string> = {
  [IconType.Collectors]: "collectors",
  [IconType.HwrcSites]: "hwrc-sites",
  [IconType.DisposalSites]: "disposal-sites",
  [IconType.Regions]: "regions",
  [IconType.NonWorkingPeriods]: "non-working-periods",
  [IconType.FillThreshold]: "fill-threshold",
  [IconType.SLA]: "sla",
  [IconType.SystemSetup]: "system-setup"
};

export const IconTypeLink: Record<IconType, string> = {
  [IconType.Collectors]: "collectors",
  [IconType.HwrcSites]: "hwrcsites",
  [IconType.DisposalSites]: "disposalsites",
  [IconType.Regions]: "regions",
  [IconType.NonWorkingPeriods]: "nonworkingperiods",
  [IconType.FillThreshold]: "setthreshold",
  [IconType.SLA]: "sla",
  [IconType.SystemSetup]: "systemsettings"
};

export const IconTypeDescription: Record<IconType, string> = {
  [IconType.Collectors]: "Collectors",
  [IconType.HwrcSites]: "HWRC Sites",
  [IconType.DisposalSites]: "Disposal Sites",
  [IconType.Regions]: "Regions",
  [IconType.NonWorkingPeriods]: "Non-Working Periods",
  [IconType.FillThreshold]: "Fill Threshold",
  [IconType.SLA]: "SLA",
  [IconType.SystemSetup]: "System Setup"
};

export const IconTypeComponent: Record<IconType, JSX.Element> = {
  [IconType.Collectors]: <Truck color="white" size={42} />,
  [IconType.HwrcSites]: <GeoAltFill color="white" size={42} />,
  [IconType.DisposalSites]: <PinMap color="white" size={42} />,
  [IconType.Regions]: <Map color="white" size={42} />,
  [IconType.NonWorkingPeriods]: <CalendarX color="white" size={42} />,
  [IconType.FillThreshold]: <Speedometer color="white" size={42} />,
  [IconType.SLA]: <Alarm color="white" size={42} />,
  [IconType.SystemSetup]: <Gear color="white" size={42} />
};
